import { i18, currencyFormat } from 'src/Utilities';

export const ForexExchangePreview = (props) => {
  if (!props) {
    return null;
  }

  const { From, To, AmountFrom, AmountTo, BankRate, Pair } = props.forexDraftInfo?.Calculation ?? {};

  return {
    parts: [
      {
        title: i18.PaymentParts.Payer,
        fields: [
          {
            title: i18.Labels.FromAccount,
            value: props.forexDraftInfo?.IBANAccountFrom,
          },
          {
            title: i18.Labels.ToAccount,
            value: props.forexDraftInfo?.IBANAccountTo,
          },
        ],
      },
      {
        title: i18.PaymentParts.AdditionalInformation,
        fields: [
          {
            title: i18.Labels.CurrencyFrom,
            value: `${currencyFormat(AmountFrom, 2)} ${From}`,
          },
          {
            title: i18.Labels.CurrencyTo,
            value: `${currencyFormat(AmountTo, 2)} ${To}`,
          },
          {
            title: i18.Labels.FixRate,
            value: Pair,
            secondLine: currencyFormat(BankRate, 6),
          },
        ],
      },
    ],
  };
};
